import React, { KeyboardEvent } from 'react';

import Icon, { ICON_TYPE_CLOSE } from '../../../Icon';
import './FileItem.css';

interface FileItemProps {
    children?: React.ReactNode;
    onDelete?: (event?: React.SyntheticEvent) => void;
}

const FileItem: React.FC<FileItemProps> = ({
    onDelete = () => null,
    children = null,
}) => {
    const onPressEnter = (
        event: KeyboardEvent<HTMLSpanElement>
    ) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            onDelete(event);
        }
    };

    return (
        <div className="FileItem">
            <span className="upload-list-item-content">
                {children}
            </span>

            <Icon
                onClick={onDelete}
                role="button"
                tabIndex={0}
                onKeyDown={onPressEnter}
                type={ICON_TYPE_CLOSE}
                className="action-delete"
            />
        </div>
    );
};

export default FileItem;